import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import Slide from '@mui/material/Slide';
import { useLocation, useNavigate } from "react-router-dom";
import defColors from "utils/defColors";
import { useTheme } from "@emotion/react";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const MainTitleBox = ({ children }) => {
    //useDarkMode()
    
    const containerRef = React.useRef(null);
    const [checked, setChecked] = React.useState(false);

    const TitleBox = styled(Box)(({ theme }) => ({
        fontSize: '36px',
        padding: theme.spacing(1.2, 8, 1.2, 3),
        background: defColors.mainTitleBackground1,
        color: 'white',
        textAlign: 'center',
        clipPath: 'polygon(0% 0%, 100% 0%, calc(100% - 40px) 100%, 0% 100%)'
    }));

    const BorderBox = styled(TitleBox)(({ theme }) => ({
        position: 'absolute',
        right: -1,
        bottom: -1,
        background: defColors.mainTitleBackground2,
    }));

    const navigate = useNavigate();
    const location = useLocation();

    const linkHandler = (to) => {
        if (location.pathname.startsWith('/dashboard/'))
            navigate(-1)
    }

    useEffect(() => {
        setChecked(true)
    }, [])

    return (
        <Box sx={{ position: 'absolute', left: 0, top: 0, }} ref={containerRef}>
            <Slide timeout={1000} in={checked} direction="down" container={containerRef.current} easing={{ enter: "ease-out", exit: "ease-in" }}>
                <Box sx={{ position: 'relative', left: 0, top: 0, my: 2 }} onClick={linkHandler}>
                    <BorderBox>{children}</BorderBox>
                    <TitleBox sx={{ my: 2 }}>{children}</TitleBox>
                </Box>
            </Slide>
        </Box>
    )
}

const ParentBox = ({ children, title, updateTime }) => {
  
    const theme = useTheme();
    const defaultTheme = React.useMemo(
      () =>
        createTheme({
          ...theme,
          palette: {
            mode:'dark',
          },
        }),
      [theme],
    );

    return (
        <ThemeProvider theme={defaultTheme}>
        <Box sx={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', color:'white' }}>
            <Box sx={{position:'absolute', left: 0, top: 0, width:'100%', height:'100%', p:1}}>
                <Box sx={{position: 'relative', width: '100%', height: '100%', borderRadius:1}}/>
            </Box>
            {children}
            {
                updateTime &&
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={1}
                    sx={{ position: 'absolute', right: 0, top: 0, m: 2 }}>
                    <CircularProgress size={16} color="inherit" />
                    <Typography variant="h5">업데이트 {updateTime}</Typography>
                </Stack>
            }
        </Box>
          </ThemeProvider>
    )
}

export default ParentBox